export default "__VITE_ASSET__CR6zSZ74__"